/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcceptRenewalTermsDto } from '../models/AcceptRenewalTermsDto';
import type { AcceptRenewalTermsResponseDto } from '../models/AcceptRenewalTermsResponseDto';
import type { AssignRenewalAdviserDto } from '../models/AssignRenewalAdviserDto';
import type { CalculatePremiumFundingDto } from '../models/CalculatePremiumFundingDto';
import type { CheckPolicyRenewalResponseDto } from '../models/CheckPolicyRenewalResponseDto';
import type { CreateRenewalQuoteResponseDto } from '../models/CreateRenewalQuoteResponseDto';
import type { MarkRenewalLostDto } from '../models/MarkRenewalLostDto';
import type { MockRenewalCheckDto } from '../models/MockRenewalCheckDto';
import type { PaginatedRenewalsResponseDto } from '../models/PaginatedRenewalsResponseDto';
import type { RenewalDetailResponseDto } from '../models/RenewalDetailResponseDto';
import type { SendRenewalEmailDto } from '../models/SendRenewalEmailDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RenewalsService {
    /**
     * List renewals
     * Returns paginated renewals with optional filters for status, renewalType, policyId, and search term. Pass includeStats=true to receive global dashboard summary counts (unaffected by list filters). Supports sortBy (renewalType, renewalDate, daysUntil) and sortOrder (asc, desc).
     * @param page Page number (1-based)
     * @param limit Items per page
     * @param status Filter by renewal workflow status
     * @param renewalType Filter by renewal type
     * @param search Search by renewal number, policy, or client name
     * @param policyId Filter by policy ID
     * @param includeStats Include global summary counts for the renewals dashboard cards
     * @param sortBy Sort field
     * @param sortOrder Sort order
     * @returns PaginatedRenewalsResponseDto
     * @throws ApiError
     */
    public static renewalsControllerFindAll(
        page: number = 1,
        limit: number = 20,
        status?: 'PENDING' | 'AWAITING_CLIENT_RESPONSE' | 'CONFIRMED_NO_CHANGE' | 'REQUEST_CALLBACK' | 'PENDING_AMENDMENTS' | 'AWAITING_UPDATED_PRICING' | 'UPDATED_TERMS_RECEIVED' | 'PRICING_FINALISED' | 'SENT_TO_CLIENT' | 'AWAITING_PAYMENT' | 'RENEWED_SUCCESSFULLY' | 'LAPSED' | 'LOST' | 'INSURER_REVIEW',
        renewalType?: 'AUTOMATIC' | 'MANUAL',
        search?: string,
        policyId?: string,
        includeStats: boolean = false,
        sortBy?: 'renewalType' | 'renewalDate' | 'daysUntil',
        sortOrder: 'asc' | 'desc' = 'asc',
    ): CancelablePromise<PaginatedRenewalsResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/renewals',
            query: {
                'page': page,
                'limit': limit,
                'status': status,
                'renewalType': renewalType,
                'search': search,
                'policyId': policyId,
                'includeStats': includeStats,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
            },
            errors: {
                401: `Unauthorized - JWT token missing/invalid`,
            },
        });
    }
    /**
     * Get renewal detail
     * @param renewalId Renewal UUID
     * @returns RenewalDetailResponseDto
     * @throws ApiError
     */
    public static renewalsControllerFindById(
        renewalId: string,
    ): CancelablePromise<RenewalDetailResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/renewals/{renewalId}',
            path: {
                'renewalId': renewalId,
            },
            errors: {
                400: `Renewal not found`,
                401: `Unauthorized - JWT token missing/invalid`,
            },
        });
    }
    /**
     * Mark renewal as lost
     * Sets workflow status to LOST, stores loss details in meta, and sets lapsedAt (request body or server time).
     * @param renewalId Renewal UUID
     * @param requestBody
     * @returns RenewalDetailResponseDto
     * @throws ApiError
     */
    public static renewalsControllerMarkRenewalLost(
        renewalId: string,
        requestBody: MarkRenewalLostDto,
    ): CancelablePromise<RenewalDetailResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/renewals/{renewalId}/lost',
            path: {
                'renewalId': renewalId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Renewal not found or not eligible to mark lost`,
                401: `Unauthorized - JWT token missing/invalid`,
            },
        });
    }
    /**
     * Create or open combined quote from renewal terms
     * Builds a local Quote (classification RENEWAL) from renewal.terms.quote_details, linked to the renewal. Reuses an in-progress linked quote when one already exists.
     * @param renewalId Renewal UUID
     * @returns CreateRenewalQuoteResponseDto
     * @throws ApiError
     */
    public static renewalsControllerCreateRenewalQuote(
        renewalId: string,
    ): CancelablePromise<CreateRenewalQuoteResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/renewals/{renewalId}/quotes',
            path: {
                'renewalId': renewalId,
            },
            errors: {
                400: `Renewal not found or terms incomplete`,
                401: `Unauthorized - JWT token missing/invalid`,
            },
        });
    }
    /**
     * Manually check policy renewal terms
     * Calls Ando renewal terms endpoint and creates/updates the single renewal record for this policy when terms exist.
     * @param policyId Policy UUID
     * @returns CheckPolicyRenewalResponseDto
     * @throws ApiError
     */
    public static renewalsControllerCheckPolicyForRenewal(
        policyId: string,
    ): CancelablePromise<CheckPolicyRenewalResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/policies/{policyId}/renewal/check',
            path: {
                'policyId': policyId,
            },
            errors: {
                400: `Policy not found or invalid for renewal check`,
                401: `Unauthorized - JWT token missing/invalid`,
            },
        });
    }
    /**
     * [Dev] Check policy renewal using mock Ando terms
     * Development-only. Builds mock Ando renewal terms from the local policy snapshot and runs the normal renewal check flow without calling ANDO. Useful for one-off testing when app.ando.mockRenewals is disabled.
     * @param policyId Policy UUID
     * @param requestBody
     * @returns CheckPolicyRenewalResponseDto
     * @throws ApiError
     */
    public static renewalsControllerCheckPolicyForRenewalWithMockTerms(
        policyId: string,
        requestBody: MockRenewalCheckDto,
    ): CancelablePromise<CheckPolicyRenewalResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/policies/{policyId}/renewal/check-mock',
            path: {
                'policyId': policyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Policy not found or invalid for renewal check`,
                401: `Unauthorized - JWT token missing/invalid`,
                403: `Not available outside development/test`,
            },
        });
    }
    /**
     * [Dev] Preview mock Ando renewal terms for a policy
     * Development-only. Returns the mock renewal terms payload that would be injected into renewal/check-mock or when app.ando.mockRenewals is enabled.
     * @param policyId Policy UUID
     * @param premiumMultiplier Multiply source policy premium by this factor for the mock renewal (default 1.05)
     * @param coverStartDate Override mock renewal cover start date (ISO-8601 date string). Must be supplied together with coverEndDate.
     * @param coverEndDate Override mock renewal cover end date (ISO-8601 date string). Must be supplied together with coverStartDate.
     * @param renewalQuoteId Override mock Ando renewal quote_id
     * @returns void
     * @throws ApiError
     */
    public static renewalsControllerPreviewMockRenewalTerms(
        policyId: string,
        premiumMultiplier?: number,
        coverStartDate?: string,
        coverEndDate?: string,
        renewalQuoteId?: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/policies/{policyId}/renewal/mock-terms',
            path: {
                'policyId': policyId,
            },
            query: {
                'premiumMultiplier': premiumMultiplier,
                'coverStartDate': coverStartDate,
                'coverEndDate': coverEndDate,
                'renewalQuoteId': renewalQuoteId,
            },
            errors: {
                401: `Unauthorized - JWT token missing/invalid`,
                403: `Not available outside development/test`,
            },
        });
    }
    /**
     * Calculate premium funding for a renewal
     * Reuses or creates a draft eOffer for the linked renewal quote and persists an NZFS premium funding quote.
     * @param policyId Policy UUID
     * @param requestBody
     * @returns any Premium funding calculated
     * @throws ApiError
     */
    public static renewalsControllerCalculateRenewalPremiumFunding(
        policyId: string,
        requestBody: CalculatePremiumFundingDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/policies/{policyId}/renewal/premium-funding/calculate',
            path: {
                'policyId': policyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `No linked renewal quote, or quote is missing Ando totals/cover start`,
                401: `Unauthorized - JWT token missing/invalid`,
            },
        });
    }
    /**
     * Manually accept renewal terms
     * Calls Ando accept renewal endpoint and persists renewed policy, risks, and invoice using the selected payment method.
     * @param policyId Policy UUID
     * @param requestBody
     * @returns AcceptRenewalTermsResponseDto
     * @throws ApiError
     */
    public static renewalsControllerAcceptPolicyRenewal(
        policyId: string,
        requestBody: AcceptRenewalTermsDto,
    ): CancelablePromise<AcceptRenewalTermsResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/policies/{policyId}/renewal/accept',
            path: {
                'policyId': policyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Policy not found or invalid for renewal acceptance`,
                401: `Unauthorized - JWT token missing/invalid`,
            },
        });
    }
    /**
     * Assign or unassign an adviser on a renewal
     * Sets the assignedAdviserId on the renewal. Pass null or omit adviserId to unassign. The assigned adviser becomes the servicing adviser of the new policy when the renewal is bound.
     * @param renewalId Renewal UUID
     * @param requestBody
     * @returns RenewalDetailResponseDto
     * @throws ApiError
     */
    public static renewalsControllerAssignRenewalAdviser(
        renewalId: string,
        requestBody: AssignRenewalAdviserDto,
    ): CancelablePromise<RenewalDetailResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/renewals/{renewalId}/adviser',
            path: {
                'renewalId': renewalId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Renewal or adviser not found`,
                401: `Unauthorized - JWT token missing/invalid`,
            },
        });
    }
    /**
     * Disable auto-renewal
     * Flips renewalType to MANUAL and records autoRenewalDisabledAt. Available to advisers, business admins, and super admins.
     * @param renewalId Renewal UUID
     * @returns RenewalDetailResponseDto
     * @throws ApiError
     */
    public static renewalsControllerDisableAutoRenewal(
        renewalId: string,
    ): CancelablePromise<RenewalDetailResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/renewals/{renewalId}/disable-auto-renewal',
            path: {
                'renewalId': renewalId,
            },
            errors: {
                400: `Renewal not found or not currently automatic`,
                401: `Unauthorized - JWT token missing/invalid`,
            },
        });
    }
    /**
     * Email renewal details to client
     * Sends the renewal client email with an optional custom opening message and e-offer link.
     * @param renewalId Renewal UUID
     * @param requestBody
     * @returns RenewalDetailResponseDto
     * @throws ApiError
     */
    public static renewalsControllerSendRenewalEmailToClient(
        renewalId: string,
        requestBody: SendRenewalEmailDto,
    ): CancelablePromise<RenewalDetailResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/renewals/{renewalId}/email-client',
            path: {
                'renewalId': renewalId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Renewal not found or e-offer link unavailable`,
                401: `Unauthorized - JWT token missing/invalid`,
            },
        });
    }
}
